import { Inventory } from '../types/inventory';
import { InjectionToken } from '@angular/core';
import { ApiDataAccess, ResponseResult } from '@softline/core';
import {
  SOFTLINE_API_INVENTORY_DEFAULT_STORAGE,
  SOFTLINE_API_INVENTORY_GET_ACTIVE,
  SOFTLINE_API_INVENTORY_SUBMIT,
} from '../inventory.api';
import { InventoryStorage } from '../types/inventory-storage';

export interface InventoryRepository {
  loadExisting(): Promise<Inventory | null>;
  cancel(): Promise<unknown>;
  finish(params: { schwundlisteDrucken: boolean; differenz: number }): Promise<unknown>;
  loadDefaultLager(): Promise<InventoryStorage | null>;
}

export const SOFTLINE_MDE_INVENTORY_REPOSITORY = new InjectionToken<InventoryRepository>(
  'SOFTLINE_MDE_INVENTORY_REPOSITORY'
);

export class DefaultInventoryRepository implements InventoryRepository {
  constructor(protected dataAccess: ApiDataAccess) {}

  async loadExisting(): Promise<Inventory | null> {
    const response = await this.dataAccess.get<ResponseResult<Inventory>>({
      path: SOFTLINE_API_INVENTORY_GET_ACTIVE,
    });

    return response?.result ?? null;
  }

  async loadDefaultLager(): Promise<InventoryStorage | null> {
    const response = await this.dataAccess.get<ResponseResult<InventoryStorage>>({
      path: SOFTLINE_API_INVENTORY_DEFAULT_STORAGE,
    });

    return response?.result ?? null;
  }

  async cancel(): Promise<unknown> {
    return this.dataAccess.delete({
      path: SOFTLINE_API_INVENTORY_GET_ACTIVE,
    });
  }

  async finish(params: {
    schwundlisteDrucken: boolean;
    differenz: number;
  }): Promise<unknown> {
    return this.dataAccess.create(
      {
        path: SOFTLINE_API_INVENTORY_SUBMIT,
      },
      params
    );
  }
}
